import PraisoServices from "./PraisoServices";
import { getToken } from "./LocalStorageService";

export const GetCountryListAPI = async (params?: any) => {
    const ApiUrl = `country/search`;
    const token = getToken();
    try {
        const response = await PraisoServices(
            ApiUrl,
            "get",
            {},
            {
                ...params,
            },
            {
                Authorization: `Bearer ${token}`,
            }
        );
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
};

export const GetUserLicenseAPI = async (userId: string, viewType: number) => {
    const ApiUrl = `licenses`;
    const token = getToken();
    try {
        const response = await PraisoServices(
            ApiUrl,
            "get",
            {},
            {
                "userId": userId,
                "viewType": viewType
            },
            {
                Authorization: `Bearer ${token}`,
            }
        );
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
};

export const UpsertLicenseAPI = async (licenseObj) => {
    window.localStorage.removeItem("API");
    const ApiUrl = `licenses`;
    const token = getToken();
    try {
        const response = await PraisoServices(
            ApiUrl,
            "post",
            {
                ...licenseObj,
            },
            {},
            {
                Authorization: `Bearer ${token}`,
            }
        );
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
};

export const ValidateLicenseAPI = async (id) => {
    const ApiUrl = `licenses/validate/${id}`;
    const token = getToken();
    try {
        const response = await PraisoServices(
            ApiUrl,
            "get",
            {},
            {
            },
            {
                Authorization: `Bearer ${token}`,
            }
        );
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
};

export const SendEConsentAPI = async (id) => {
    const ApiUrl = `licenses/sendeconsent/${id}`;
    const token = getToken();
    try {
        const response = await PraisoServices(
            ApiUrl,
            "get",
            {},
            {
            },
            {
                Authorization: `Bearer ${token}`,
            }
        );
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
};

export const DeleteLicenseAPI = async (licenseObj) => {
    console.log("RemoveLicenseAPI");
    window.localStorage.removeItem("API");
    const ApiUrl = `licenses`;
    const token = getToken();
    try {
        const response = await PraisoServices(
            ApiUrl,
            "delete",
            {},
            {
                id: licenseObj.id
            },
            {
                Authorization: `Bearer ${token}`,
            }
        );
        console.log("RemoveLicenseAPI Response:", response);
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
};

export const SendUserEConsentAPI = async (id) => {
    const ApiUrl = `licenses/sendeconsent/user/${id}`;
    const token = getToken();
    try {
        const response = await PraisoServices(
            ApiUrl,
            "get",
            {},
            {
            },
            {
                Authorization: `Bearer ${token}`,
            }
        );
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
};

export const GetUserLicenseLogsAPI = async (licenseDetailsId: string) => {
    const ApiUrl = `licenses/logs/${licenseDetailsId}`;
    const token = getToken();
    try {
        const response = await PraisoServices(
            ApiUrl,
            "get",
            {},
            {},
            {
                Authorization: `Bearer ${token}`,
            }
        );
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
};